module.exports = __webpack_public_path__ + "img/front exposed 10mm zipper length.3ec61c64.png";